<template>
	<div v-if="!isSuccess">
		<div style="background-color: #E18738;height: 179px;text-align: center;">
			<img :src="require('@/assets/img/Road_rescue.png')" style="width: 100px;height: 100px;margin-top: 40px;" />
		</div>
		<van-form label-width="65px" @submit="submit" style="padding-top: 13px;">
			<van-cell-group inset>
				<van-field v-model="newForm.phone" type="tel" name="phone" :label="$t('msg.phone')"
					:placeholder="$t('msg.phonePlaceholder')"
					:rules="[{ required: true, message: $t('msg.phoneMessage') }]" />
				<van-field v-model="newForm.address" type="textarea" show-word-limit maxlength="50" name="address"
					:label="$t('msg.rescueAddress')" :placeholder="$t('msg.rescueAddressPlaceholder')"
					:rules="[{ required: true, message: $t('msg.rescueAddressMessage') }]" />

				<van-field v-model="newForm.repair" type="textarea" show-word-limit maxlength="300" name="content"
					:label="$t('msg.rescueContent')" :placeholder="$t('msg.rescueContentPlaceholder')"
					:rules="[{ required: true, message: $t('msg.rescueContentMessage') }]" />

				<van-field name="uploader" :label="$t('msg.imgUploader')">
					<template #input>
						<div @click="uploadImg">
							<div style="background-color: #EFF1F3;">
								<Image :src="newForm.imgUrl" width="95px" height="95px">
									<template #error>
										<Icon type="ios-image-outline" size="60" color="#ccc" />
									</template>
									<!-- <template #loading>
									  <Icon type="ios-loading" size="60" color="#4C92EF" />
									</template> -->
								</Image>

							</div>
							<div style="width: 95px;text-align: center;">
								<span style="color: #9095A6; font-size: 12px;">{{ newForm.imgUrl != null &&
                                    newForm.imgUrl != '' ?
                                    $t('msg.clickSwitchImg') : $t('msg.clickUploadImg') }}</span>
							</div>
						</div>

						<!-- 上传加载动画 -->
						<!-- <div v-if="isUploading" style="width: 95px; height: 95px; display: flex; align-items: center; justify-content: center; background-color: #EFF1F3;">
							<van-loading type="circular" color="#4C92EF" />
						</div> -->
					</template>
				</van-field>
			</van-cell-group>
			<div style="margin: 16px;">
				<van-button round block native-type="submit" style="background-color: #E18738;">
					{{ $t("msg.submit") }}
				</van-button>
			</div>
		</van-form>
	</div>

	<div v-if="isSuccess" style="margin: 0px;padding: 0px;margin-top: 160px; text-align: center;position: relative;">
		<img :src="require('@/assets/img/success.png')" style="width: 124px;height: 124px;" />
		<div class="center" style="margin-top: 18px; width: 284px;">
			<span style="color: #9095A6; font-size: 18px;">{{ $t("msg.submitPrompt") }}</span>
		</div>
	</div>
</template>

<script>
	import {
		useI18n
	} from "vue-i18n";
	import {
		useStore
	} from "vuex";
	import http from '../utils/request.js'
	import {
		uploadFile
	} from '../utils/upload.js'
	import api from '../api/index.js'
	import {
		Loading
	} from 'vant'; // 导入vant的Loading组件

	export default {
		components: {
			// 注册Loading组件
			[Loading.name]: Loading
		},
		data() {
			return {
				isSuccess: false,
				isUpload: false,
				// isUploading: false, // 控制上传加载动画
				newForm: {
					type: 1,
					address: '',
					phone: '',
					imgUrl: '',
					repair: '',
					latitude: '',
					longitude: '',
					motoId: '',
					deptId: ''
				},
				imgUrl: []
			}
		},
		methods: {
			submit() {
				if (this.newForm.imgUrl == null || this.newForm.imgUrl == '') {
					this.$Message.error(this.$t('msg.imgUploaderMessage'));
					return;
				}
				api.systemServiceApi.createRepair(this.newForm)
					.then((result) => {
						if (result != null) {
							// 弹出成功提示
							this.$Message.success(this.$t('msg.submitSuccess'));
							this.isSuccess = true;
						}
					});
			},
			uploadImg() {
				// 1. 创建 input 元素
				const input = document.createElement('input');
				input.type = 'file';
				input.accept = 'image/*';

				// 使用 Promise 包装文件选择
				input.onchange = (e) => new Promise(async (resolve, reject) => {
					const file = e.target.files[0];
					if (!file) return reject('未选择文件');

					try {
						// 2. 获取上传 URL
						const res = await api.systemServiceApi.getUploadUrl({
							fileSuffix: file.name.split('.').pop(),
							fileType: 0
						});

						if (res.code !== 200) throw new Error('获取上传链接失败');

						// 3. 上传文件
						await uploadFile(res.data.url, file);

						// 4. 上传成功后再设置URL
						this.newForm.imgUrl = res.data.url.split('?')[0];
						console.log('上传完成后的URL:', this.newForm.imgUrl);
						resolve();
					} catch (error) {
						console.error('上传失败:', error);
						this.$Message.error('上传失败，请重试');
						reject(error);
					}
				});

				input.click();
			},
			// afterRead(file) {
			// 	if (file.content.startsWith("data:image/")) {
			// 		this.uploadImg(file)
			// 	} else {
			// 		this.$Message.error(this.$t('msg.imgUploaderMessage'));
			// 		this.imgUrl = []
			// 		this.newForm.imgUrl = '';
			// 	}

			// },
			// beforeDelete(file, detail) {
			// 	this.imgUrl = []
			// 	this.newForm.imgUrl = '';
			// },
		},
		mounted() {
			this.newForm.motoId = this.$route.query.motoId;
			this.newForm.deptId = this.$route.query.deptId;
			this.newForm.address = this.$route.query.address;
			this.newForm.longitude = this.$route.query.lon;
			this.newForm.latitude = this.$route.query.lat;
			document.querySelector('body').setAttribute('style', 'background-color:#eff2f5');
			document.title = this.$t('msg.roadRescue')

		}
	}
</script>
<style>
	.center {
		text-align: center;
		position: absolute;
		left: 50%;
		transform: translate(-50%);
	}
</style>